/* jshint ignore:start */
import React from "react";
import './VideoDetail.css';
const VideoDetail = ({ videoDetail }) => {
  
  const videoSrc = `https://www.youtube.com/embed/${videoDetail.id.videoId}`;
  return (
    <div className="card">
      <div className="card-body">
        <div className="embed-responsive embed-responsive-16by9 frame">
          <iframe
            className="embed-responsive-item"
            src={videoSrc}
            title={videoDetail.id.videoId} allowFullScreen></iframe>
        </div>
        {/* <div className="embed-responsive embed-responsive-1by1">
          <iframe
            className="embed-responsive-item"
            src={videoSrc}
            title={videoDetail.id.videoId}
            style={{ width: "inherit" }}
            allowfullscreen></iframe>
        </div> */}
        <div className="col">
          <h4 className="card-title">{videoDetail.snippet.title}</h4>
          <p className="card-text">{videoDetail.snippet.description}</p>
        </div>
      </div>
    </div>
  );
};

export default VideoDetail;
